import { defineFilterSchema } from '@/lib/filterSchema'
import type { SealedProductFilters } from '@/types'

/**
 * Single source of truth for the sealed-products filter fields that round-trip
 * through the URL. Same derivation as the card schema (see `@/lib/filterSchema`).
 * `q`/`sort`/`order` round-trip but aren't active-counted; `sort`/`order` carry
 * the page defaults.
 *
 * Note: `ownership` exists on `SealedProductFilters` but isn't URL-synced on
 * this page (it never was) — don't add it here.
 */
export const SEALED_FILTER_SCHEMA = defineFilterSchema<SealedProductFilters>()({
  q: { kind: 'string', active: false },
  productType: { kind: 'string' },
  setCode: { kind: 'string' },
  sort: { kind: 'string', active: false, default: 'name' },
  order: { kind: 'string', active: false, default: 'asc' },
})
